import { toast } from 'react-toastify'
import { Link2 } from 'lucide-react'
import url from 'libraries/front-end-core/core/url'
import { getBaseURI } from 'libraries/front-end-core/helpers/document'
import { DOCUMENTS_CONTENT } from 'constants/controllers'
import notificationToast from 'helpers/notificationToast'
import TealToolTip from 'components/TealToolTip'
import { AOL_CORPORATE } from 'constants/aol/aol'

export default function CopyLink ({ rootId, documentId }: { rootId: string, documentId: string }): JSX.Element {
  const id = url(DOCUMENTS_CONTENT, { aol: AOL_CORPORATE, sectionId: rootId, focusedId: documentId })

  return (
    <TealToolTip
      title='Copy (unique document) link to clipboard'
      bgColor='dark'
      placement='top'
      arrow={false}
    >
      <a
        href={undefined}
        data-clipboard-text={id}
        onClick={() => {
          void navigator.clipboard.writeText(getBaseURI() + id)
          notificationToast(<Link2 />, toast.TYPE.INFO, 'Link copied to clipboard')
        }}
        className='pointer flex items-center justify-center bg-transparent hover-bg-ghost-white focus-bg-ghost-white w8 hs8 br2 p0 ml5 ml0-m'
      >
        <Link2
          strokeWidth={1.5}
          size={24}
          className='w7 hs7 min-w7 grey'
        />
      </a>
    </TealToolTip>
  )
}
